import type { CellRendererContext } from "echart-table-library";

/**
 * Business callback: app-level tooltip formatter shared by demo and chart
 * widgets. Preserves the native ECharts `params` argument (convention 7.2).
 */
export function demoTooltip(params: unknown): string {
  const list = Array.isArray(params) ? params : [params];
  const lines = list.map((item) => {
    const p = item as { name?: string; seriesName?: string; value?: unknown };
    return `${p.seriesName ?? ""}: ${String(p.value ?? "")}`;
  });
  return [`<strong>${(list[0] as { name?: string })?.name ?? ""}</strong>`, ...lines].join(
    "<br/>",
  );
}

// Cell renderer context is accepted for signature parity with the registry.
export type TooltipContext = CellRendererContext;
